// Servicios
import Ambulancias from "../assets/Servicios/Iconos servicios 2026-01.png";
import AreaShock from "../assets/Servicios/Iconos servicios 2026-02.png";
import CirugiaHolep from "../assets/Servicios/Iconos servicios 2026-03.png";
import Electrocardiograma from "../assets/Servicios/Iconos servicios 2026-04.png";
import EsterelizacionPlasma from "../assets/Servicios/Iconos servicios 2026-05.png";
import Farmacia from "../assets/Servicios/Iconos servicios 2026-06.png";
import Hospitalizacion from "../assets/Servicios/Iconos servicios 2026-07.png";
import Laboratorio from "../assets/Servicios/Iconos servicios 2026-08.png";
import MapeoPresionArterial from "../assets/Servicios/Iconos servicios 2026-09.png";
import Marcapasos from "../assets/Servicios/Iconos servicios 2026-10.png";
import MembresiaSalud from "../assets/Servicios/Iconos servicios 2026-11.png";
import PaquetesCirugias from "../assets/Servicios/Iconos servicios 2026-12.png";
import Quirofanos from "../assets/Servicios/Iconos servicios 2026-13.png";
import RayosX from "../assets/Servicios/Iconos servicios 2026-14.png";
import ResonanciaMagnetica from "../assets/Servicios/Iconos servicios 2026-15.png";
import SalaDeEndoscopia from "../assets/Servicios/Iconos servicios 2026-16.png";
import SegurosMedicos from "../assets/Servicios/Iconos servicios 2026-17.png";
import ServiciosOftalmologicos from "../assets/Servicios/Iconos servicios 2026-18.png";
import TamizNeonatal from "../assets/Servicios/Iconos servicios 2026-19.png";
import Tomografia from "../assets/Servicios/Iconos servicios 2026-20.png";
import Ultrasonidos from "../assets/Servicios/Iconos servicios 2026-21.png";
import UnidadDeCuidadosIntensivosNeonatales from "../assets/Servicios/Iconos servicios 2026-22.png";
import UnidadDeTerapiaIntermedia from "../assets/Servicios/Iconos servicios 2026-23.png";
import UrgenciasHoras from "../assets/Servicios/Iconos servicios 2026-24.png";

// Informacion Especialistas Medicos
import archivoDePrueba from "../assets/Especialistas/Informacion_Especialista/PATRONESCOLOR.pdf";

// Servicios Informacion
export const dataServicios = [
  {
    id: "service-001",
    titulo: "Tomografía",
    subtitulo: "Técnica diagnóstica que combina rayos X y procesamiento digital para crear cortes transversales tridimensionales del cuerpo. Facilita la detección rápida de fracturas complejas, tumores y hemorragias internas.",
    image: Tomografia,
    telefono: "311 214 0083 / Ext. 149",
    numero: "3112140083",
    tipo: "Estudios de imagen",
    pdf: archivoDePrueba
  },
  {
    id: "service-002",
    titulo: "Urgencias las 24 horas",
    subtitulo: "Área de atención inmediata disponible de forma permanente para la valoración y tratamiento de eventos médicos críticos o inesperados por parte de especialistas.",
    image: UrgenciasHoras,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Urgencias"
  },
  {
    id: "service-003",
    titulo: "Laboratorio las 24 horas",
    subtitulo: "Servicio continuo de análisis clínicos para el procesamiento de muestras biológicas a cualquier hora del día. Entrega resultados oportunos para respaldar diagnósticos precisos en emergencias y hospitalización.",
    image: Laboratorio,
    telefono: "(311) 214 0083 / Ext. 116",
    numero: "3112140083",
    tipo: "Laboratorio"
  },
  {
    id: "service-004",
    titulo: "Hospitalización",
    subtitulo: "Área equipada para brindar estancia médica, monitoreo constante y cuidados integrales a pacientes que requieren recuperación postoperatoria o tratamiento supervisado.",
    image: Hospitalizacion,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Hospitalización"
  },
  // {
  //   id: "service-005",
  //   titulo: "Terapia Intermedia",
  //   subtitulo: "Cuidado especializado para los pacientes en condiciones críticas.",
  //   image: Intermedia,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Especialistas"
  // },
  // {
  //   id: "service-006",
  //   titulo: "Traslados programados",
  //   subtitulo: "Modernas unidades equipadas para el traslados seguros dentro y fuera de la ciudad.",
  //   image: Traslados,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Atención"
  // },
  // {
  //   id: "service-007",
  //   titulo: "Cirugía HoLEP",
  //   subtitulo: "Equipo de vanguardia para el tratamiento de padecimientos de la próstata.",
  //   image: Cirugia,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Especialistas"
  // },
  // {
  //   id: "service-008",
  //   titulo: "Quirófanos",
  //   subtitulo: "Salas de quirófano con tecnología de punta para la realización de cirugías.",
  //   image: Qx,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Atención"
  // },
  // {
  //   id: "service-009",
  //   titulo: "Paquetes de maternidad",
  //   subtitulo: "Reciba a su bebé en un espacio totalmente seguro, con la mejor atención.",
  //   image: Maternidad2,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Maternidad"
  // },
  {
    id: "service-010",
    titulo: "Tamiz Neonatal",
    subtitulo: "Prueba preventiva obligatoria que se realiza mediante una pequeña punción en el talón del recién nacido. Permite identificar a tiempo enfermedades metabólicas graves para iniciar un tratamiento temprano.",
    image: TamizNeonatal,
    telefono: "(311) 214 0083 / Ext. 116",
    numero: "3112140083",
    tipo: "Laboratorio"
  },
  // {
  //   id: "service-011",
  //   titulo: "Cuidados Intensivos Neonatales",
  //   subtitulo: "Cuidado especializado para los recién nacidos.",
  //   image: Cuidados,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Maternidad"
  // },
  // {
  //   id: "service-012",
  //   titulo: "Consulta externa",
  //   subtitulo: "Salas de quirófano con tecnología de punta para la realización de cirugías.",
  //   image: ConsultaExterna,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Atención"
  // },
  {
    id: "service-013",
    titulo: "Esterilización por plasma, vapor y gas",
    subtitulo: "Procesos avanzados de desinfección hospitalaria que garantizan la eliminación total de microorganismos en el instrumental médico según la delicadeza de su material.",
    image: EsterelizacionPlasma,
    telefono: "311 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Esterilización"
  },
  {
    id: "service-014",
    titulo: "Farmacia",
    subtitulo: "Servicio de abastecimiento intrahospitalario y venta al público con un catálogo amplio de medicamentos de patente y especialidad para dar continuidad a los tratamientos.",
    image: Farmacia,
    telefono: "311 214 0083 / Ext. 124",
    numero: "3112140083",
    tipo: "Farmacia"
  },
  {
    id: "service-015",
    titulo: "Sala de endoscopia",
    subtitulo: "Espacio equipado con cámaras flexibles para la exploración directa del tubo digestivo y vías respiratorias. Permite realizar diagnósticos visuales y procedimientos terapéuticos de mínima invasión.",
    image: SalaDeEndoscopia,
    telefono: "(311) 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  // {
  //   id: "service-016",
  //   titulo: "Oftálmica",
  //   subtitulo: "Detección y tratamiento de padecimientos oculares por médicos especialista.",
  //   image: Oftamica,
  //   telefono: "311 211 9470 EXT. 195",
  //   numero: "3112119470",
  //   tipo: "Especialistas"
  // },
  {
    id: "service-017",
    titulo: "Marcapasos temporal",
    subtitulo: "Dispositivo de soporte vital transitorio que regula el ritmo cardíaco mediante impulsos eléctricos en situaciones de emergencia o previas a una cirugía definitiva.",
    image: Marcapasos,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Cardiología"
  },
  {
    id: "service-018",
    titulo: "Mapeo de la presión arterial",
    subtitulo: "Registro ambulatorio que mide la presión arterial de forma continua durante 24 horas. Ayuda a diagnosticar hipertensión con precisión durante la rutina diaria del paciente.",
    image: MapeoPresionArterial,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Cardiología"
  },
  // {
  //   id: "service-019",
  //   titulo: "Holter",
  //   subtitulo: "Reciba a su bebé en un espacio totalmente seguro, con la mejor atención las 24 horas.",
  //   image: Holter,
  //   telefono: "311 211 9470 EXT. 0",
  //   numero: "3112119470",
  //   tipo: "Maternidad"
  // },
  {
    id: "service-020",
    titulo: "Área de shock",
    subtitulo: "Zona de atención prioritaria dentro de urgencias destinada a la reanimación inmediata e intervención de pacientes en estado crítico o con riesgo vital inminente.",
    image: AreaShock,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Urgencias"
  },
  {
    id: "service-021",
    titulo: "Resonancia Magnética",
    subtitulo: "Estudio de imagenología de alta precisión que utiliza campos magnéticos para obtener vistas detalladas de tejidos blandos y órganos. Permite diagnosticar lesiones neurológicas, musculares y articulares sin emitir radiación.",
    image: ResonanciaMagnetica,
    telefono: "311 214 0083 / EXT. 149",
    numero: "3112140083",
    tipo: "Estudios de imagen"
  },
  {
    id: "service-022",
    titulo: "Rayos X",
    subtitulo: "Estudio de radiología convencional rápido y no invasivo diseñado para evaluar la estructura ósea y el área torácica. Es fundamental en la detección oportuna de fracturas, luxaciones y afecciones pulmonares básicas.",
    image: RayosX,
    telefono: "311 214 0083 / Ext. 149",
    numero: "3112140083",
    tipo: "Estudios de imagen"
  },
  {
    id: "service-023",
    titulo: "Ultrasonidos",
    subtitulo: "Estudio médico basado en ondas de sonido de alta frecuencia para visualizar órganos internos y monitorear el embarazo. Es un procedimiento completamente seguro, indoloro y libre de radiación.",
    image: Ultrasonidos,
    telefono: "311 214 0083 / Ext. 158",
    numero: "3112140083",
    tipo: "Estudios de imagen"
  },
  {
    id: "service-024",
    titulo: "Unidad de Cuidados Intensivos Neonatales",
    subtitulo: "Espacio altamente especializado equipado con incubadoras y tecnología médica avanzada para la atención crítica de recién nacidos prematuros o en estado delicado.",
    image: UnidadDeCuidadosIntensivosNeonatales,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Hospitalización"
  },
  {
    id: "service-025",
    titulo: "Unidad de Terapia intermedia",
    subtitulo: "Área destinada a pacientes que requieren vigilancia continua y cuidados constantes, pero sin el grado de soporte vital invasivo que exige la terapia intensiva.",
    image: UnidadDeTerapiaIntermedia,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Hospitalización"
  },
  {
    id: "service-026",
    titulo: "Quirófanos",
    subtitulo: "Salas de operaciones diseñadas bajo estrictos estándares de esterilidad y equipamiento quirúrgico avanzado. Están preparadas para realizar intervenciones programadas y de urgencia con máxima seguridad.",
    image: Quirofanos,
    telefono: "311 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  {
    id: "service-027",
    titulo: "Cirugía con láser HoLEP, Argón, Armónico y Radiofrecuencia",
    subtitulo: "Procedimientos quirúrgicos de última generación que garantizan cortes e incisiones de alta precisión. Reducen sensiblemente el sangrado, el dolor y el tiempo de recuperación del paciente.",
    image: CirugiaHolep,
    telefono: "(311) 214 0083 / Ext. 120",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  {
    id: "service-028",
    titulo: "Paquetes de cirugías",
    subtitulo: "Planes médicos integrales que agrupan honorarios, quirófano, anestesia y estancia hospitalaria bajo un costo cerrado. Brindan certidumbre financiera y transparencia antes del procedimiento.",
    image: PaquetesCirugias,
    telefono: "311 214 0083 / Ext. 162",
    numero: "3112140083",
    tipo: "Servicios quirúrgicos"
  },
  {
    id: "service-029",
    titulo: "Electrocardiograma",
    subtitulo: "Prueba rápida que registra la actividad eléctrica del corazón en una gráfica. Es clave para detectar arritmias, evaluar la función cardíaca e identificar signos de infarto de forma inmediata.",
    image: Electrocardiograma,
    telefono: "311 214 0083 / Ext. 181",
    numero: "3112140083",
    tipo: "Cardiología"
  },
  {
    id: "service-031",
    titulo: "Ambulancias",
    subtitulo: "Unidades de traslado terrestre dotadas de equipo de soporte vital y personal capacitado para la atención prehospitalaria y el transporte seguro de pacientes.",
    image: Ambulancias,
    telefono: "311 214 0083 / Ext. 162",
    numero: "3112140083",
    tipo: "Ambulancia"
  },
  {
    id: "service-032",
    titulo: "Membresía de salud",
    subtitulo: "Programa de afiliación que otorga tarifas preferenciales, descuentos exclusivos y beneficios preventivos en consultas y estudios para el titular y sus beneficiarios.",
    image: MembresiaSalud,
    telefono: "311 214 0083 / Ext. 192",
    numero: "3112140083",
    tipo: "Membresía y seguros médicos"
  },
  {
    id: "service-033",
    titulo: "Seguros médicos",
    subtitulo: "Módulo de atención especializado para la gestión, trámite de coberturas y pase directo con las principales compañías aseguradoras del país.",
    image: SegurosMedicos,
    telefono: "311 214 0083 / Ext. 126",
    numero: "3112140083",
    tipo: "Membresía y seguros médicos"
  },
  {
    id: "service-034",
    titulo: "Servicios oftalmológicos",
    subtitulo: "Atención médica y quirúrgica orientada al diagnóstico, prevención y tratamiento integral de afecciones en la vista y la estructura ocular.",
    image: ServiciosOftalmologicos,
    telefono: "311 214 0083 / Ext. 195",
    numero: "3112140083",
    tipo: "Oftalmología"
  },
];

// Servicios Categorias
export const categoriaServicios = [
  "Estudios de imagen",
  "Laboratorio",
  "Hospitalización",
  "Servicios quirúrgicos",
  "Cardiología",
  "Urgencias",
  "Ambulancia",
  "Esterilización",
  "Farmacia",
  "Membresía y seguros médicos",
  "Oftalmología"
];
